const ButtonVariant = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  TERTIARY: "TERTIARY",
  FOURTH: "FOURTH",
};

const TYPE_BUTTON = {
  SUBMIT: "submit",
  BUTTON: "button",
  RESET: "reset",
};
export { ButtonVariant, TYPE_BUTTON };
